(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fading-announcements"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fading-announcements')) {
    customElements.define(
      'fading-announcements',
      class extends HTMLElement {
        connectedCallback() {
          this.controller = new AbortController();
          const options = { signal: this.controller.signal };
          this.slides = Array.from(this.querySelectorAll('[data-slide]'));
          this.index = 0;
          this.paused = false;
          this.selected = false;
          this.motion = matchMedia('(prefers-reduced-motion: reduce)');
          this.querySelectorAll('[data-previous], [data-next], [data-pause]').forEach((control) =>
            control.removeAttribute('hidden')
          );
          this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.index + 1), options);
          this.querySelector('[data-previous]')?.addEventListener('click', () => this.show(this.index - 1), options);
          this.querySelector('[data-pause]')?.addEventListener(
            'click',
            (event) => {
              this.paused = !this.paused;
              event.currentTarget.setAttribute('aria-pressed', String(this.paused));
              this.restart();
            },
            options
          );
          this.addEventListener('mouseenter', () => clearTimeout(this.rotation), options);
          this.addEventListener('mouseleave', () => this.restart(), options);
          this.addEventListener('focusin', () => clearTimeout(this.rotation), options);
          this.addEventListener('focusout', () => this.restart(), options);
          document.addEventListener('visibilitychange', () => this.restart(), options);
          this.motion.addEventListener('change', () => this.restart(), options);
          document.addEventListener(
            'shopify:block:select',
            (event) => {
              const index = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
              if (index < 0) return;
              this.selected = true;
              this.show(index);
            },
            options
          );
          document.addEventListener(
            'shopify:block:deselect',
            (event) => {
              if (!this.slides.some((slide) => slide.dataset.blockId === event.detail.blockId)) return;
              this.selected = false;
              this.restart();
            },
            options
          );
          this.timers = Array.from(this.querySelectorAll('[data-deadline]'))
            .map((element) => ({ element, end: this.parseDeadline(element.dataset.deadline) }))
            .filter(({ end }) => Number.isFinite(end));
          this.updateTimers();
          if (this.timers.length) this.clock = setInterval(() => this.updateTimers(), 1000);
          this.show(0);
        }
        disconnectedCallback() {
          this.controller.abort();
          clearTimeout(this.rotation);
          clearInterval(this.clock);
        }
        show(index) {
          if (!this.slides.length) return;
          this.index = (index + this.slides.length) % this.slides.length;
          this.slides.forEach((slide, position) => {
            slide.setAttribute('aria-hidden', String(position !== this.index));
            slide.inert = position !== this.index;
          });
          this.restart();
        }
        restart() {
          clearTimeout(this.rotation);
          if (this.slides.length < 2 || this.paused || this.selected || this.motion.matches || document.hidden) return;
          this.rotation = setTimeout(() => {
            if (this.matches(':hover') || this.contains(document.activeElement)) {
              this.restart();
              return;
            }
            this.show(this.index + 1);
          }, Number(this.dataset.interval) || 5000);
        }
        parseDeadline(value) {
          const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):00([+-]\d{2}:\d{2})$/.exec(value);
          if (!match) return NaN;
          const [, year, month, day, hour, minute] = match.map((part, index) =>
            index > 0 && index < 6 ? Number(part) : part
          );
          const daysInMonth = new Date(Date.UTC(year, month, 0)).getUTCDate();
          if (month < 1 || month > 12 || day < 1 || day > daysInMonth || hour > 23 || minute > 59) return NaN;
          return Date.parse(value);
        }
        updateTimers() {
          const units = this.querySelector('[data-units]').dataset;
          this.timers.forEach(({ element, end }) => {
            const seconds = Math.max(0, Math.ceil((end - Date.now()) / 1000));
            const text =
              seconds === 0
                ? element.dataset.expired
                : `${Math.floor(seconds / 86400)}${units.days} ${String(Math.floor(seconds / 3600) % 24).padStart(
                    2,
                    '0'
                  )}${units.hours} ${String(Math.floor(seconds / 60) % 60).padStart(2, '0')}${units.minutes} ${String(
                    seconds % 60
                  ).padStart(2, '0')}${units.seconds}`;
            element.querySelector('[data-time]').textContent = text;
            element.hidden = !text;
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["request-a-quote"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initQuoteSection = (section) => {
      if (!section || section.dataset.raqInitialized === 'true') return;
      section.dataset.raqInitialized = 'true';

      const rowsContainer = section.querySelector('[data-raq-rows]');
      const rowTemplate = section.querySelector('[data-raq-row-template]');
      const addButton = section.querySelector('[data-raq-add]');
      const form = section.querySelector('form');
      const compiledMessage = section.querySelector('[data-raq-compiled-message]');
      const overallNote = section.querySelector('[data-raq-overall-note]');
      const validation = section.querySelector('[data-raq-validation]');
      const limitMessage = section.querySelector('[data-raq-limit-message]');
      const maxRows = Number.parseInt(section.dataset.maxRows || '10', 10);

      if (!rowsContainer || !rowTemplate || !addButton || !form || !compiledMessage) return;

      const markFieldInvalid = (control) => {
        if (!control) return;

        control.setAttribute('aria-invalid', 'true');
        control.closest('.raq__field')?.classList.add('raq__field--invalid');
      };

      const clearFieldInvalid = (control) => {
        if (!control) return;

        control.removeAttribute('aria-invalid');
        control.closest('.raq__field')?.classList.remove('raq__field--invalid');
      };

      const updateValidationMessage = () => {
        if (!validation) return;

        const hasHighlightedErrors = Boolean(form.querySelector('.raq__field--invalid'));
        validation.hidden = !hasHighlightedErrors;
        if (hasHighlightedErrors) {
          validation.textContent = 'Please check the highlighted fields and correct them before submitting.';
        }
      };

      const clearFieldWhenValid = (event) => {
        const control = event.target.closest('input, select, textarea');
        if (!control || !form.contains(control)) return;

        if (control.checkValidity()) {
          clearFieldInvalid(control);
          updateValidationMessage();
        }
      };

      form.addEventListener(
        'invalid',
        (event) => {
          const control = event.target;
          if (
            !(
              control instanceof HTMLInputElement ||
              control instanceof HTMLSelectElement ||
              control instanceof HTMLTextAreaElement
            )
          )
            return;

          markFieldInvalid(control);
          updateValidationMessage();
        },
        true
      );

      form.addEventListener('input', clearFieldWhenValid);
      form.addEventListener('change', clearFieldWhenValid);

      const updateRowControls = () => {
        const rows = [...rowsContainer.querySelectorAll('[data-raq-row]')];
        const atLimit = rows.length >= maxRows;

        addButton.disabled = atLimit;
        if (limitMessage) limitMessage.hidden = !atLimit;

        rows.forEach((row) => {
          const removeButton = row.querySelector('[data-raq-remove]');
          if (removeButton) removeButton.hidden = rows.length === 1;
        });
      };

      const addRow = () => {
        if (rowsContainer.querySelectorAll('[data-raq-row]').length >= maxRows) return;

        const fragment = rowTemplate.content.cloneNode(true);
        const row = fragment.querySelector('[data-raq-row]');
        rowsContainer.appendChild(fragment);
        updateRowControls();

        return row;
      };

      addButton.addEventListener('click', () => {
        const row = addRow();
        row?.querySelector('[data-raq-product]')?.focus();
      });

      rowsContainer.addEventListener('click', (event) => {
        const removeButton = event.target.closest('[data-raq-remove]');
        if (!removeButton) return;

        const rows = rowsContainer.querySelectorAll('[data-raq-row]');
        if (rows.length <= 1) return;

        removeButton.closest('[data-raq-row]')?.remove();
        updateRowControls();
        updateValidationMessage();
      });

      form.addEventListener('submit', (event) => {
        const rows = [...rowsContainer.querySelectorAll('[data-raq-row]')];
        const quoteLines = [];
        let firstInvalidField = null;

        rows.forEach((row, index) => {
          const productField = row.querySelector('[data-raq-product]');
          const quantityField = row.querySelector('[data-raq-quantity]');
          const noteField = row.querySelector('[data-raq-note]');

          const product = productField?.value.trim() || '';
          const quantity = quantityField?.value.trim() || '';
          const note = noteField?.value.trim() || '';

          if (!product) {
            markFieldInvalid(productField);
            if (!firstInvalidField) firstInvalidField = productField;
          }

          if (!quantity) {
            markFieldInvalid(quantityField);
            if (!firstInvalidField) firstInvalidField = quantityField;
          }

          if (product && quantity) {
            let line = `${index + 1}. ${product} — Quantity: ${quantity}`;
            if (note) line += ` — Size / note: ${note}`;
            quoteLines.push(line);
          }
        });

        if (!quoteLines.length || firstInvalidField) {
          event.preventDefault();
          if (validation) {
            validation.textContent = 'Please check the highlighted fields and correct them before submitting.';
            validation.hidden = false;
          }
          firstInvalidField?.focus();
          return;
        }

        form.querySelectorAll('.raq__field--invalid').forEach((field) => {
          field.classList.remove('raq__field--invalid');
          field.querySelectorAll('[aria-invalid="true"]').forEach((control) => control.removeAttribute('aria-invalid'));
        });
        if (validation) validation.hidden = true;

        const messageParts = ['QUOTE REQUEST', '', 'Products requested:', ...quoteLines];
        const extraNote = overallNote?.value.trim();

        if (extraNote) {
          messageParts.push('', 'Additional information:', extraNote);
        }

        compiledMessage.value = messageParts.join('\n');
      });

      addRow();
    };

    const initAllQuoteSections = (root = document) => {
      if (root.matches?.('[data-raq-section]')) initQuoteSection(root);
      root.querySelectorAll?.('[data-raq-section]').forEach(initQuoteSection);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAllQuoteSections());
    } else {
      initAllQuoteSections();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initAllQuoteSections(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
